import { render, staticRenderFns } from "./CardCreate.vue?vue&type=template&id=1285f1be&scoped=true&"
import script from "./CardCreate.vue?vue&type=script&lang=js&"
export * from "./CardCreate.vue?vue&type=script&lang=js&"
import style0 from "./CardCreate.vue?vue&type=style&index=0&id=1285f1be&scoped=true&lang=scss&"
import style1 from "./CardCreate.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1285f1be",
  null
  
)

export default component.exports